<template>
  <div class="page overflow-auto">
    <AppHeader :title="$t('pages.password_reset')" :is-main="false">
      <div slot="right">
        <el-button class="py-2" size="mini" @click="onBack">
          {{ $t('general.back') }}
        </el-button>
      </div>
    </AppHeader>
    <PasswordResetView />
  </div>
</template>

<script>
import AppHeader from '../../components/navigation/AppHeader';
import PasswordResetView from '../../views/password-reset/PasswordResetView';
export default {
  name: 'PasswordResetPage',
  components: { PasswordResetView, AppHeader },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    onBack() {
      this.$router.push({ name: this.$routeNames.LOGIN_PAGE_ROUTE });
    },
  },
};
</script>

<style scoped></style>
